import { Routes } from "@angular/router";
import { APPROUTES } from "../../app.routes.strings";
import { ShipmentsComponent } from "./shipments.component";
import { AuthGuardService } from "app/infrastructure/oidc/auth-guard.service";

export const SHIPMENT_ROUTES: Routes = [
  { path: APPROUTES.shipments, component: ShipmentsComponent, canActivate: [AuthGuardService] },
];
